import { useState } from 'react';
import { TEXT_MUTED, BORDER_DEFAULT, TEXT_HEADING, TEXT_DEFAULT, BG_SURFACE, FIELD_ERROR_BORDER, FONT_LABEL, FONT_TINY } from '../../theme';

const inputStyle = {
  ...FONT_LABEL,
  width: '100%', padding: '0.55rem 0.7rem',
  border: `1px solid ${BORDER_DEFAULT}`,
  borderRadius: 6, background: BG_SURFACE,
  color: TEXT_HEADING, outline: 'none', boxSizing: 'border-box',
};

export default function TagInput({ tags, onAdd, onRemove, onUpdate, placeholder, disabled }) {
  const [input, setInput] = useState('');
  const [editingTag, setEditingTag] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const [errorTag, setErrorTag] = useState(null);

  const add = () => {
    const v = input.trim();
    if (!v || tags.includes(v)) return;
    onAdd(v);
    setInput('');
  };

  const cancelEdit = () => {
    setEditingTag(null);
    setEditingValue('');
  };

  const commitEdit = () => {
    if (editingTag === null) return;
    const trimmed = editingValue.trim();
    if (trimmed === '') { cancelEdit(); return; }
    if (trimmed === editingTag) { cancelEdit(); return; }
    if (tags.includes(trimmed)) {
      setErrorTag(editingTag);
      setTimeout(() => setErrorTag(null), 1000);
      cancelEdit();
      return;
    }
    onUpdate(editingTag, trimmed);
    cancelEdit();
  };

  const startEdit = (tag) => {
    if (disabled) return;
    if (typeof onUpdate !== 'function') return;
    setEditingTag(tag);
    setEditingValue(tag);
  };

  return (
    <div>
      {tags.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.4rem' }}>
          {tags.map((tag) => (
            editingTag === tag ? (
              <input
                key={tag}
                autoFocus
                type="text"
                value={editingValue}
                onChange={(e) => setEditingValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') { e.preventDefault(); commitEdit(); }
                  else if (e.key === 'Escape') { e.preventDefault(); cancelEdit(); }
                }}
                onBlur={commitEdit}
                style={{
                  ...FONT_TINY,
                  background: '#e0e7ef', color: TEXT_DEFAULT, borderRadius: 4,
                  padding: '0.12rem 0.35rem 0.12rem 0.45rem',
                  border: 'none', outline: 'none',
                  width: `${Math.max(editingValue.length + 1, 8)}ch`,
                }}
              />
            ) : (
              <span key={tag} onDoubleClick={() => startEdit(tag)} style={{
                ...FONT_TINY,
                display: 'inline-flex', alignItems: 'center', gap: '0.2rem',
                background: '#e0e7ef', color: TEXT_DEFAULT, borderRadius: 4,
                padding: '0.12rem 0.35rem 0.12rem 0.45rem',
                border: errorTag === tag ? `1px solid ${FIELD_ERROR_BORDER}` : undefined,
              }}>
                {tag}
                <button
                  type="button"
                  onClick={() => onRemove(tag)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: TEXT_MUTED, padding: 0, fontSize: '0.85rem', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                >×</button>
              </span>
            )
          ))}
        </div>
      )}
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
        onBlur={() => add()}
        placeholder={placeholder}
        disabled={disabled}
        style={inputStyle}
      />
    </div>
  );
}
